import { render, staticRenderFns } from "./AgentCommissionRemittance.vue?vue&type=template&id=34a0b30b&"
import script from "./AgentCommissionRemittance.vue?vue&type=script&lang=js&"
export * from "./AgentCommissionRemittance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports